<template>
  <div class="homepage-carousel-container">
    <ImpressionTrackingContainer
      v-if="recommendations.length"
      :threshold="[0.5]"
      root-margin="-15% 0% 0%"
      @track-impression="trackCarouselImpression"
    >
      <HomePageCarousel
        :title="$t('carousel.recommendedForYou')"
        :products="recommendations"
        @track-product-impression="trackProductImpression"
        @track-product-click="trackProductClicked"
      />
    </ImpressionTrackingContainer>

    <HomePageCarousel
      v-for="carousel in carousels"
      :key="carousel.id"
      :title="carousel.attributes.title"
      :products="carouselProducts(carousel)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HomePageCarousel from './HomePageCarousel.vue'

export default {
  name: 'HomePageCarouselContainer',

  components: {
    HomePageCarousel
  },

  computed: {
    ...mapGetters({
      carousels: 'homePageCarousel/carousels',
      products: 'homePageCarousel/products',
      recommendations: 'productRecommendations/recommendations',
      recommendationId: 'productRecommendations/recommendationId',
      splitKey: 'productRecommendations/splitKey',
      strategy: 'productRecommendations/strategy',
      userId: 'user/id',
      cardNumber: 'user/cardNumber'
    }),
    getTrackingParams() {
      return {
        origin: `homepage${this.strategy ? `|${this.strategy}` : ''}`,
        recommendation_id: this.recommendationId,
        carousel_name: 'recommended_for_you',
        card_number: this.cardNumber,
        session_id: this.$cookies.get('_ga_6KSFTBFXP6')?.split('.')[2],
        page_path: this.$route.path,
        user_id: this.userId,
        site_country: this.$i18n.countryCode.toLowerCase(),
        traffic_split_key: this.splitKey
      }
    }
  },

  mounted() {
    // Fetch product recommendations on client side only for now
    // We need to pass PRODUCT_VIEWS data inside the request body which is currently stored in localstorage
    this.$store.dispatch('productRecommendations/fetchProductRecommendations', {
      path: this.$route.path,
      recommendationsCount: 8
    })
  },

  methods: {
    carouselProducts(carousel) {
      return carousel.relationships.products.data.map((product) =>
        this.products.find((data) => data.id === product.id)
      )
    },

    trackCarouselImpression() {
      this.$analytics.trackEvent(
        'recommended_for_you_impression',
        this.getTrackingParams
      )
    },

    trackProductImpression(product, cardSequence) {
      this.$analytics.trackEvent('recommended_for_you_card_impression', {
        ...this.getTrackingParams,
        product_id: product.id,
        variant_id: product.featuredVariant.id,
        card_sequence_num: cardSequence
      })
    },

    trackProductClicked(product, cardSequence) {
      this.$analytics.trackEvent('product_click', {
        ...this.getTrackingParams,
        product_id: product.id,
        variant_id: product.featuredVariant.id,
        product_tag: product.label,
        card_sequence_num: cardSequence
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.homepage-carousel-container {
  width: 100%;
}
</style>
